import React from 'react';
import { Provider } from 'react-redux';
import namingStore from '../common/store/naming_store.js';
import WithAppTopContexts from "../common/components/with_app_top_contexts";
import Index from './components/index.js';

const App = (props) => {
  return (
    <Provider store={ namingStore }>
      <WithAppTopContexts initProps={ props }>
        <Index { ...props } />
      </WithAppTopContexts>
    </Provider>
  );
};

export default App;
